import { FilterType } from "src/api/types";
import { LABEL } from "src/constants/searchParams";

export const filters: FilterType[] = [
  {
    name: LABEL,
    placeholder: "Label",
    type: "text",
  },
];
